import { useEffect } from 'react'
import toast from 'react-hot-toast';
import { setAuthToken, setUserData } from '../lib/client';
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

export const KakaoCallbackPage = () => {
  const apiUrl = import.meta.env.VITE_API_URL;
  const redirectUrl = decodeURIComponent(window.location.search.split('state=')[1]);
  const navigate = useNavigate();

  async function fetchKakao(code: string) {
    if(!apiUrl) {
      toast.error('통신 오류가 발생했습니다.');
      navigate('/auth', { replace: true });
      return
    }
    const res = await fetch(`${apiUrl}/auth/kakao?code=${code}&platform=${isMobile ? 'mobile-web' : 'desktop-web'}`);
    const data = await res.json();
    if(data.success) {
      setUserData(data.user);
      setAuthToken(data.token);
      navigate(redirectUrl || '/', { replace: true });
    } else {  
      toast.error(data.error);
      navigate('/auth', { replace: true });
    }
  }

  useEffect(() => {
    const code = window.location.search.split('code=')[1];
    fetchKakao(code);
  }, []);

  return (
    <div className='w-full min-h-[100svh] flex flex-col gap-1 items-center justify-center text-xl text-[#333333]'>
      <span>카카오 로그인을 진행 중입니다.</span>
      <span>페이지를 벗어나지 마세요!</span>
      <div className="mt-4">
        <div className="w-8 h-8 border-4 border-[#FEE500] border-t-transparent rounded-full animate-spin"></div>
      </div>
    </div>
  )
}
